import React, {createContext, useContext, useState} from 'react';
import {createPortal} from 'react-dom';
import './SideMenuTabs.css';

// Ярлыки рынка политик у левого края экрана (своя политика, рынок) — только
// на телефоне: на десктопе рынок открывается из шапки, а список игроков на
// любой ширине — строкой игроков в шапке. Ярлыки живут в PolicyMarketSideMenu,
// но на экране это одна колонка от низа шапки: колонку рисует GameContent,
// ярлыки попадают в нее порталом. Порядок в колонке — CSS order
// (SIDE_MENU_TAB_ORDER), а не порядок монтирования: ярлык, появившийся позже
// (своя политика — после покупки), встает на свое место, а не в конец колонки
const SideMenuTabsContext = createContext(undefined);

export const SIDE_MENU_TAB_ORDER = Object.freeze({
  OWN_POLICY: 1,
  POLICY_MARKET: 2,
});

/**
 * Колонка ярлыков. Дети — остальное содержимое экрана матча, которому нужен
 * доступ к колонке (боковые меню)
 */
export function SideMenuTabsProvider({children}) {
  const [tabsNode, setTabsNode] = useState(null);

  return (
    <SideMenuTabsContext.Provider value={tabsNode}>
      <div className={'side-menu-tabs'} ref={setTabsNode} data-field-inset={'left'}/>
      {children}
    </SideMenuTabsContext.Provider>
  );
}

/**
 * Ярлык в колонке. Без колонки (компонент отрисован отдельно — тесты,
 * витрина) ярлык остается на месте
 */
export function SideMenuTab({children}) {
  const tabsNode = useContext(SideMenuTabsContext);

  if (tabsNode === undefined) {
    return children;
  }
  // Колонка еще не смонтирована — первый кадр
  if (tabsNode === null) {
    return null;
  }
  return createPortal(children, tabsNode);
}
